import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';


const MyPackagingType = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [packageType, setPackageType] = useState([]);

    useEffect(() => {
        ReadAxios({
            completeURL: `${process.env.REACT_APP_MASTER_API}/packaging_type`,
            // payload: { searchTerm: searchTerm },
        }).then((result) => {
            let list = result.data.resultSet.map((item, index) => {
                return {
                    key: item.packagingTypeId,
                    text: item.packagingType,
                    value: item.packagingTypeId,
                    raw: { ...item },
                };
            });
            setPackageType(list);
        });
    }, [])

    return (
        <Dropdown
            selection
            // loading={isloading}
            style={{ width: "100%" }}
            // search
            onChange={(value, data) => setFieldValue(name, data.value)}
            options={packageType}
            {...props}
        />

    )
}

export default MyPackagingType